import { useCallback, useEffect, useMemo } from 'react';

import { selectLastNavigationItemSelectedIds } from '../../ducks/navigation_history/selectors';
import { updateLastNavigationHistoryItem } from '../../ducks/navigation_history/slice';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';

const defaultDisabledIds: string[] = [];

export const useNavigationHistory = (
  ids: string[],
  disabledIds: string[] = defaultDisabledIds,
) => {
  const dispatch = useAppDispatch();

  const navigationSelectedIds = useAppSelector(
    selectLastNavigationItemSelectedIds,
  );
  const selectedIds = useMemo(() => {
    const disabledIdsSet = new Set(disabledIds);
    return navigationSelectedIds.filter((id) => !disabledIdsSet.has(id));
  }, [navigationSelectedIds, disabledIds]);

  const handleSelectIds = useCallback((value: string[]) => {
    dispatch(
      updateLastNavigationHistoryItem({
        selectedIds: value,
      }),
    );
  }, []);

  useEffect(() => {
    dispatch(
      updateLastNavigationHistoryItem({
        listIds: ids,
      }),
    );
  }, [ids]);

  const scrollToFirstSelectedId = useCallback(() => {
    const id = selectedIds[0];
    const lastViewedItemElement = document.querySelector(
      `[role='listbox'][aria-label='Content items'] [data-id='${id}']`,
    );
    if (!lastViewedItemElement) {
      return;
    }
    lastViewedItemElement.scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'nearest',
    });
  }, [selectedIds[0]]);

  return [selectedIds, handleSelectIds, scrollToFirstSelectedId] as const;
};
